<template>
  <div>
    <b-col>
        <b-row class="d-flex vh-100 justify-content-center align-items-center">
          <b-col>
            <TallyDisplay
              :client="client"
              :tally="selected"
              :status="statusName"
              @live="test"
            />
          </b-col>
        </b-row>


        <b-row>
          <b-form-select v-model="selected" :options="values"></b-form-select>
        </b-row>
        <b-row>

      <b-col class="text-center p-5" align-v="center">
        <TallyDisplay
          :client="client"
          tally="mrm/qh1a/tally1"
          status="mrm/qh1a/status"
        />
        <TallyDisplay
          :client="client"
          tally="mrm/qh1a/tally2"
          status="mrm/qh1a/status"
        />
        <TallyDisplay
          :client="client"
          tally="mrm/qh1a/tally3"
          status="mrm/qh1a/status"
        />
        <TallyDisplay
          :client="client"
          tally="mrm/qh1a/tally4"
          status="mrm/qh1a/status"
        />
      </b-col>
              </b-row>

    </b-col>
  </div>
</template>

<script>
import mqtt from "mqtt";

import TallyDisplay from "@/components/TallyDisplay";

export default {
  name: "Tally",
  props: {},
  computed: {
    clientId() {
      return (
        "ProgOBsClient" +
        Math.random()
          .toString(16)
          .substring(2, 8)
      );
    },
    statusName() {
      let status;
      if (this.selected) {
        let splits = this.selected.split("/");
        status = `${splits[0]}/${splits[1]}/status`;
      }
      return status;
    },
  },

  data: function() {
    return {
      client: null,
      host: "wss://mqtt.prodops.org:8081",
      options: {
        keepalive: 30,
        clientId: this.clientId,
        protocolId: "MQTT",
        protocolVersion: 4,
        clean: true,
        reconnectPeriod: 5000,
        connectTimeout: 30 * 1000,
        rejectUnauthorized: false,
      },
      connected: false,
      flag: null,
      tallyInputDevice: null,
      colour: "success",
      name: null,

      selected: null,
      values: [
        { value: null, text: "Please select an option" },
        { value: "test/device/tally1", text: "test/device/tally1" },
        { value: "test/device/tally2", text: "test/device/tally2" },
        { value: "test/device/tally3", text: "test/device/tally3" },
        { value: "test/device/tally4", text: "test/device/tally4" },
        { value: "test/device/tally5", text: "test/device/tally5" },
        { value: "mrm/qh1a/tally1", text: "mrm/qh1a/tally1" },
        { value: "mrm/qh1a/tally2", text: "mrm/qh1a/tally2" },
        { value: "mrm/qh1a/tally3", text: "mrm/qh1a/tally3" },
        { value: "mrm/qh1a/tally4", text: "mrm/qh1a/tally4" },
      ],
    };
  },

  components: {
    TallyDisplay,
  },
  methods: {
    test(flag) {
      this.$emit("test", flag);
    },
  },

  beforeMount() {
    console.log(`Client ID: ${this.clientId}`);
    this.client = mqtt.connect(this.host, this.options);

    this.client.subscribe("#", { qos: 2 });

    this.client.on("connect", () => {
      this.connected = true;
      console.log("connected to broker");
    });

    this.client.on("error", (err) => {
      console.log(`Error: ${err}`);
    });

    this.client.on("reconnect", () => {
      console.log("Reconnecting...");
    });
  },
};
</script>
